import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const getInitialDarkMode = (): boolean => {
  try {
    const stored = localStorage.getItem("darkMode");
    if (stored !== null) return JSON.parse(stored);
  } catch {
    void 0;
  }
  const hour = new Date().getHours();
  return hour >= 17 || hour < 5;
};

const initialState: { darkMode: boolean } = {
  darkMode: getInitialDarkMode(),
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setDarkMode: (
      state: { darkMode: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.darkMode = action.payload;
    },
  },
});

export const { setDarkMode } = themeSlice.actions;
export default themeSlice.reducer;
